import React from "react";
import {  isAndroid, isIOS } from "react-device-detect";
import { Redirect } from "react-router-dom";

function RedirectToStores() {

  React.useEffect(() => {

    if (isIOS) {
      window.location.replace("https://apps.apple.com/tr/app/e-investor/id1529630101");
    } else if (isAndroid) {
      window.location.replace("https://play.google.com/store/apps/details?id=tr.com.mkk.EYATMobileApp");
    } else {
      // Desktop vs istersen farklı davran
       window.location.replace('/auth/login'); 
    }

  }, []);

  return null;
}

export default RedirectToStores;